import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const GOALS = 'goals'

/**
 * Form model
 */
const formModel = () => {
  return {
    [GOALS]: {
      label: `Goals`,
      name: GOALS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [GOALS]: '',
}


export default formModel
